/**
 * Libs (rendo disponibili globalmente)
 */
import Utilities from "./lib/Utilities";
import Form from "./lib/Form";
window.Form = Form;
window.Utilities = Utilities;


/**
 * DOM ready
 */
$(function() {
    
});


/**
 * Load
 */
$(window).on("load", function() {

    /**
     * Init di barba
     * Deve essere incluso nella blade base!
     * L'evento "loadermanager-page_loaded" viene lanciato quando la coda
     * di LoaderManager è stata svuotata
     */
    $(document).on("loadermanager-page_loaded", function() {

       // barbaInit();

        setTimeout(function() {
            pageEnter();
        }, 200);

    });


    /**
     * Fine caricamento
     */
    LoaderManager.eventComplete("site_loading");

    /**
     * Evento di render di un form livewire,
     * scroll al primo messaggio di errore
     * (emettere l'evento nel metodo render di un form gestito con Livewire)
     */
    window.addEventListener('form:rendered', event => {

        let form = $(event.target);

        if (form.find('.uk-form-danger').length) {
            form.find('.uk-form-danger').eq(0)[0].scrollIntoView({
                behaviour : 'smooth',
                block : 'center',
            });
        }
    });


    /**
     * gestione menu e header
     */
    (function() {

        const mainMenu = (isResize) => {

            // inserisco padding su contenuto per far spazio all'header in fixed
            if(!$('body').hasClass('header-overlay')) {
                $('#main-wrapper').css({
                    paddingTop: $('.pageHeader').outerHeight()
                });
            }

            // al resize esegue solo le operazioni sopra
            if(isResize == true) {
                return;
            }
    
            // apertura / chiusura menu
            $('.pageHeader__menuToggler').on('click', function(e) {
                e.preventDefault();
    
                if($('.mainMenu').is(':visible')) {
                    $('body').removeClass('menuOpened');
                    $('.mainMenu').fadeOut();
                } else {
                    $('body').addClass('menuOpened');
                    $('.mainMenu').fadeIn();
                }
    
            });
    
            // aggiunta classe per cambio bg
            window.addEventListener('scroll', function(){
                if (this.scrollY >= 200) {
                    $('body').addClass('scrolling');
                } else {
                    $('body').removeClass('scrolling');
                }
            });
        }

        mainMenu(false);

        window.addEventListener('resize', () => {
            mainMenu(true);
        });

    })();


    /**
     * Init di lazysizes
     */
    document.addEventListener('lazyloaded', function(e){
        e.target.classList.remove('loading');
    });
    lazySizes.init();


});


/**
 * Funzione di uscita pagina
 */
function pageExit(callback)
{}


/**
 * Funzione di entrata pagina
 */
function pageEnter(callback)
{
    
    $("#page_loader").fadeOut(function() {
        if(callback && typeof(callback) == 'function') {
            callback();
        }
    });
}

(function customCursor()
{
    $(function() {

        let cursor;

        if( ! $('html').hasClass('no-touch')){
            return;
        }

        //rollover con icona che segue il cursore 
        cursor = $('<div class="myCursor follow"></div>').appendTo('body');
        var $mouseX = 0, 
            $mouseY = 0;
        var $xp = 0, 
            $yp =0;
        
        $(document).on("mousemove", function(e) {
            $mouseX = e.pageX;
            $mouseY = e.pageY; 
        });
        
        var $loop = setInterval(function(){
            $xp += (($mouseX - $xp)/5);
            $yp += (($mouseY - $yp)/5);
            cursor.css({left:$xp +'px', top:$yp +'px'});  
        }, 30);
        
        //play stop
        $(".ej-hover-play").on("mouseenter", function() {
            cursor.addClass("play");

            if($(this).is('.playing')) {
                cursor.addClass("stop");
            } else {
                cursor.addClass("play");
            }
            if($(this).hasClass("invert")){
                cursor.addClass("invert");
            }
        });
        $(".ej-hover-play").on("mouseleave", function() {
            cursor.removeClass("play stop");
            cursor.removeClass("invert");
        });

        // "scopri"
        $(".ej-hover-scopri").on("mouseenter", function() {
            cursor.addClass("scopri");
            cursor.text($(this).attr('data-cursor'));
        }).on("mouseleave", function() {
            cursor.removeClass("scopri").text('');
        });

        // scroll
        $(".ej-hover-scroll").on("mouseenter", function() {
            cursor.addClass("scroll");
        }).on("mouseleave", function() {
            cursor.removeClass("scroll");
        });

    });
})();